import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94ae1880"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "master-detail-layout" }
const _hoisted_2 = { class: "list-panel" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h2", null, "Work Experience"),
    /*#__PURE__*/_createElementVNode("p", null, "Add your professional experience")
  ])
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag-handle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grip-vertical" })
], -1))
const _hoisted_6 = { class: "list-item-content" }
const _hoisted_7 = { class: "list-item-title" }
const _hoisted_8 = { class: "list-item-subtitle" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "detail-panel"
}
const _hoisted_14 = { class: "form-grid" }
const _hoisted_15 = { class: "form-group col-span-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Job Title / Role", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Company Name", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Company Location", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "form-group col-span-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Employment Period", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "form-group col-span-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Key Achievements & Responsibilities", -1))
const _hoisted_29 = { class: "achievements-list" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag-handle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grip-vertical" })
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bullet-point" }, "•", -1))
const _hoisted_32 = ["value", "onInput"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))

import { ref, computed, watch } from "vue";
import { VueDraggableNext } from "vue-draggable-next";
import type { WorkExperience } from "../../../../server/src/models/Resume";


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkExperienceSection',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const workExperience = ref<WorkExperience[]>([...props.modelValue]);
const selectedIndex = ref(0);

const selectedWork = computed(() => {
  if (!workExperience.value.length) return null;
  return workExperience.value[selectedIndex.value];
});

watch(
  () => props.modelValue,
  (newValue) => {
    // Only update if different to prevent recursion
    if (JSON.stringify(newValue) !== JSON.stringify(workExperience.value)) {
      workExperience.value = [...newValue];
    }
  },
  { deep: true }
);

function updateWorkExperience(value: WorkExperience[]) {
  workExperience.value = value;
  emit("update:modelValue", value);
}

function updateField(field: keyof WorkExperience, value: string) {
  if (!selectedWork.value) return;

  const newWorkExperience = [...workExperience.value];
  newWorkExperience[selectedIndex.value] = {
    ...newWorkExperience[selectedIndex.value],
    [field]: value,
  };

  workExperience.value = newWorkExperience;
  emit("update:modelValue", newWorkExperience);
}

function updateAchievement(index: number, value: string) {
  if (!selectedWork.value || !selectedWork.value.achievements) return;

  const newWorkExperience = [...workExperience.value];
  const achievements = [...(newWorkExperience[selectedIndex.value].achievements || [])];

  achievements[index] = {
    ...achievements[index],
    achievement: value,
  };

  newWorkExperience[selectedIndex.value] = {
    ...newWorkExperience[selectedIndex.value],
    achievements,
  };

  workExperience.value = newWorkExperience;
  emit("update:modelValue", newWorkExperience);
}

function addWorkExperience() {
  const newWorkExperience = [...workExperience.value];
  newWorkExperience.unshift({
    company: "",
    location: "",
    role: "",
    dates: "",
    achievements: [
      {
        achievement: "",
        uuid: crypto.randomUUID(),
      },
    ],
    uuid: crypto.randomUUID(),
  });
  updateWorkExperience(newWorkExperience);
  selectedIndex.value = 0;
}

function removeWorkExperience(index: number) {
  const newWorkExperience = [...workExperience.value];
  newWorkExperience.splice(index, 1);
  if (selectedIndex.value >= newWorkExperience.length) {
    selectedIndex.value = Math.max(0, newWorkExperience.length - 1);
  }
  updateWorkExperience(newWorkExperience);
}

function addAchievement() {
  if (selectedWork.value) {
    const newWorkExperience = [...workExperience.value];
    const work = newWorkExperience[selectedIndex.value];
    if (!work.achievements) {
      work.achievements = [];
    }
    work.achievements.push({
      achievement: "",
      uuid: crypto.randomUUID(),
    });
    updateWorkExperience(newWorkExperience);
  }
}

function removeAchievement(index: number) {
  if (selectedWork.value?.achievements) {
    const newWorkExperience = [...workExperience.value];
    const work = newWorkExperience[selectedIndex.value];
    if (!work.achievements) return;
    work.achievements.splice(index, 1);
    updateWorkExperience(newWorkExperience);
  }
}

function emitUpdate() {
  emit("update:modelValue", [...workExperience.value]);
}

// Add v-auto-resize directive
const vAutoResize = {
  mounted: (el: HTMLTextAreaElement) => {
    const resize = () => {
      el.style.height = "auto";
      el.style.height = el.scrollHeight + "px";
    };
    resize();
    el.addEventListener("input", resize);
    el.addEventListener("change", resize);
  },
  updated: (el: HTMLTextAreaElement) => {
    el.style.height = "auto";
    el.style.height = el.scrollHeight + "px";
  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(VueDraggableNext), {
        "model-value": workExperience.value,
        "onUpdate:modelValue": updateWorkExperience,
        group: "work-experience",
        handle: ".drag-handle",
        tag: "div",
        class: "item-list"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workExperience.value, (work, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["list-item", { active: selectedIndex.value === index }]),
              onClick: ($event: any) => (selectedIndex.value = index)
            }, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(work.role || "New Position"), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(work.company || "Company Name"), 1)
              ]),
              _createElementVNode("button", {
                class: "btn-remove",
                onClick: _withModifiers(($event: any) => (removeWorkExperience(index)), ["stop"])
              }, _hoisted_11, 8, _hoisted_9)
            ], 10, _hoisted_4))
          }), 128))
        ]),
        _: 1
      }, 8, ["model-value"]),
      _createElementVNode("button", {
        class: "btn-add-position",
        onClick: addWorkExperience
      }, [
        _hoisted_12,
        _createTextVNode(" Add Position ")
      ])
    ]),
    (selectedWork.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("input", {
                value: selectedWork.value.role,
                type: "text",
                placeholder: "e.g., Senior Software Engineer",
                class: "form-control",
                onInput: _cache[0] || (_cache[0] = ($event: any) => (updateField('role', ($event.target as HTMLInputElement).value)))
              }, null, 40, _hoisted_17)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("input", {
                value: selectedWork.value.company,
                type: "text",
                placeholder: "e.g., Google",
                class: "form-control",
                onInput: _cache[1] || (_cache[1] = ($event: any) => (updateField('company', ($event.target as HTMLInputElement).value)))
              }, null, 40, _hoisted_20)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("input", {
                value: selectedWork.value.location,
                type: "text",
                placeholder: "e.g., Mountain View, CA",
                class: "form-control",
                onInput: _cache[2] || (_cache[2] = ($event: any) => (updateField('location', ($event.target as HTMLInputElement).value)))
              }, null, 40, _hoisted_23)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("input", {
                value: selectedWork.value.dates,
                type: "text",
                placeholder: "e.g., Jan 2020 - Present",
                class: "form-control",
                onInput: _cache[3] || (_cache[3] = ($event: any) => (updateField('dates', ($event.target as HTMLInputElement).value)))
              }, null, 40, _hoisted_26)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_unref(VueDraggableNext), {
                  modelValue: selectedWork.value.achievements,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedWork.value.achievements) = $event)),
                  group: "achievements",
                  handle: ".drag-handle",
                  tag: "div",
                  onChange: emitUpdate
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedWork.value.achievements, (achievement, aIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: achievement.uuid,
                        class: "achievement-item"
                      }, [
                        _hoisted_30,
                        _hoisted_31,
                        (selectedWork.value && selectedWork.value.achievements)
                          ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                              key: 0,
                              value: achievement.achievement,
                              class: "form-control",
                              placeholder: "e.g., Led a team of 5 developers to deliver a key feature that increased user engagement by 25%",
                              rows: "1",
                              onInput: ($event: any) => (updateAchievement(aIndex, ($event.target as HTMLTextAreaElement).value))
                            }, null, 40, _hoisted_32)), [
                              [vAutoResize]
                            ])
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "btn-remove-small",
                          onClick: ($event: any) => (removeAchievement(aIndex))
                        }, _hoisted_35, 8, _hoisted_33)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("button", {
                  class: "btn-add-achievement",
                  onClick: addAchievement
                }, [
                  _hoisted_36,
                  _createTextVNode(" Add Achievement ")
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})